<template>
<div>
    <b-datepicker :first-day-of-week="1" :nearby-selectable-month-days="true" :day-names="['So','Mo','Di','Mi','Do','Fr','Sa',]" :month-names="['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember']" label-position="" v-model="date" :min-date="minP" :focused-date="focus" :max-date="maxP" :placeholder="placeholder" :icon="icon" :icon-pack="pack" @input="$emit('change', temp)" :inline="inline" range></b-datepicker>
</div>
</template>

<script>
export default {
    name: 'Rangepicker',
    model: {
        prop: 'dateParsed',
        event: 'change'
    },
    props: {
        dateParsed: Array,
        placeholder: String,
        icon: String,
        pack: String,
        inline: Boolean,
        min: String,
        max: String
    },
    data() {
        return {
            temp: this.dateParsed
        }
    },
    computed: {
        date: {
            get() {
                if (this.dateParsed) {
                    return [this.$moment(this.dateParsed[0], "YYYY-MM-DD").toDate(), this.$moment(this.dateParsed[1], "YYYY-MM-DD").toDate()]
                }

            },
            set(val) {
                this.temp = [this.$moment(val[0]).format('YYYY-MM-DD'), this.$moment(val[1]).format('YYYY-MM-DD')]
            }
        },
        minP() {
            if (this.min) {
                return this.$moment(this.min, 'YYYY-MM-DD').toDate()
            } else {
                let date = this.$moment().subtract(3, 'M')
                return date.toDate()
            }

        },
        maxP() {
            if (this.max) {
                return this.$moment(this.max, 'YYYY-MM-DD').toDate()
            } else {
                let date = this.$moment().add(5, 'y')
                return date.toDate()
            }
        },
        focus() {
            if (this.dateParsed) {
                return this.$moment(this.dateParsed[0], "YYYY-MM-DD").toDate()
            } else {
                return this.$moment().toDate()
            }

        }
    }
}
</script>
